// import React from "react";
// import "./QrCode.css";

// const QrCode = () => {
//     const socialLinks = [
//         {
//             name: "Facebook",
//             url: "https://facebook.com",
//             icon: "https://cdn-icons-png.flaticon.com/512/733/733547.png",
//         },
//         {
//             name: "Instagram",
//             url: "https://instagram.com",
//             icon: "https://cdn-icons-png.flaticon.com/512/2111/2111463.png",
//         },
//         {
//             name: "YouTube",
//             url: "https://cdn-icons-png.flaticon.com/512/1384/1384060.png",
//             icon: "https://cdn-icons-png.flaticon.com/512/1384/1384060.png",
//         },
//         {
//             name: "LinkedIn",
//             url: "https://linkedin.com",
//             icon: "https://cdn-icons-png.flaticon.com/512/3536/3536505.png",
//         },
//     ];

//     return (
//         <div className="socialqr-main-container">
//             <div className="socialqr-card">
//                 <h1 className="socialqr-title">Connect With Us</h1>

//                 <p className="socialqr-subtitle">
//                     Please follow us on our social media platforms for the latest updates and offers.

//                 </p>

//                 <div className="socialqr-icons-container">
//                     {socialLinks.map((item, index) => (
//                         <a
//                             href={item.url}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             className="socialqr-icon-box"
//                             key={index}
//                         >
//                             <img
//                                 src={item.icon}
//                                 alt={item.name}
//                                 className="socialqr-icon-image"
//                             />

//                             <span className="socialqr-icon-name">{item.name}</span>
//                         </a>
//                     ))}
//                 </div>


//             </div>
//         </div>
//     );
// };

// export default QrCode;






import React from "react";
import "./QrCode.css";

const QrCode = () => {
    const socialLinks = [
        {
            name: "Facebook",
            url: "https://www.facebook.com/profile.php?id=61585309266874",
            icon: "https://cdn-icons-png.flaticon.com/512/733/733547.png",
            color: "#1877F2"
        },
        {
            name: "Instagram",
            url: "https://www.instagram.com/bgrealstate360",
            icon: "https://cdn-icons-png.flaticon.com/512/2111/2111463.png",
            color: "#E4405F"
        },
        {
            name: "YouTube",
            url: "https://www.youtube.com/channel/UCxYJ1sBCI22V-ynJ63XhHYg",
            icon: "https://cdn-icons-png.flaticon.com/512/1384/1384060.png",
            color: "#FF0000"
        },
        {
            name: "LinkedIn",
            url: "https://www.linkedin.com/feed/",
            icon: "https://cdn-icons-png.flaticon.com/512/3536/3536505.png",
            color: "#0A66C2"
        },
    ];

    return (
        <div className="socialqr-main-container">
            <div className="socialqr-card">
                <div className="socialqr-header">
                    <span className="socialqr-badge">Follow Us</span>
                    <h1 className="socialqr-title">Connect With Us</h1>
                    <p className="socialqr-subtitle">
                        Stay updated with the latest news, offers, and exclusive content
                    </p>
                </div>

                <div className="socialqr-icons-container">
                    {socialLinks.map((item, index) => (
                        <a
                            href={item.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="socialqr-icon-box"
                            key={index}
                            aria-label={`Follow us on ${item.name}`}
                            style={{ '--hover-color': item.color }}
                        >
                            <div className="socialqr-icon-wrapper">
                                <img
                                    src={item.icon}
                                    alt={`${item.name} icon`}
                                    className="socialqr-icon-image"
                                    loading="lazy"
                                />
                            </div>
                            <span className="socialqr-icon-name">{item.name}</span>
                            <span className="socialqr-follow-btn">Follow →</span>
                        </a>
                    ))}
                </div>

                {/* <div className="socialqr-footer">
                    <div className="socialqr-stats">
                        <div className="socialqr-stat">
                            <span className="socialqr-stat-number">10K+</span>
                            <span className="socialqr-stat-label">Followers</span>
                        </div>
                        <div className="socialqr-stat-divider"></div>
                        <div className="socialqr-stat">
                            <span className="socialqr-stat-number">24/7</span>
                            <span className="socialqr-stat-label">Support</span>
                        </div>
                        <div className="socialqr-stat-divider"></div>
                        <div className="socialqr-stat">
                            <span className="socialqr-stat-number">100%</span>
                            <span className="socialqr-stat-label">Authentic</span>
                        </div>
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default QrCode;